/**
 * Sprint S13.1.A — onboarding step progress indicator.
 * S13.1.B.2 — mobile-responsive text + aria-label на outer wrapper.
 */
import { useTranslation } from "react-i18next";

interface Props {
  currentIndex: number;
  total: number;
}

export function OnboardingProgress({ currentIndex, total }: Props) {
  const { t } = useTranslation();
  const percent = Math.round(((currentIndex + 1) / total) * 100);

  return (
    <div
      className="mb-6"
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={currentIndex + 1}
      aria-label={t("onboarding.progress.aria_label", {
        defaultValue: "Onboarding progress",
      })}
    >
      <div className="mb-2 flex items-center justify-between text-[12px] text-taupe sm:text-[13px]">
        <span>
          {t("onboarding.progress.step", { current: currentIndex + 1, total })}
        </span>
        <span className="font-medium">{percent}%</span>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-cream-border">
        <div
          className="h-full rounded-full bg-amber transition-all duration-300"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}
